module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAATCAYAAACk9eypAAAA9ElEQVQokXXRMShFYRiA4edcKcXCKBM2NjZZZZRRCbnKQlE2d7o2IVkMlFusMrIqm0VdI5OMLBSJa7iduj7/Odt5v+/56z8nG7yrnWHG36eOUXyGroQVPIc+jGpczsELFtEIs3WMpQBc4ijM2lBDZwrkJz4GNIDtIvCGBfwEtIyJFIBr7IWW4RjdKQCbuA+tD/tF4APz+Ap9FtMpALe4SPRqERjBVKJXUqBD8/u3h36K8xTYwlBoT1jl/6XHsRZaA2W8RtCFk8Qhh7jKX1qHO+gPyw/YaA05mMRSWP7GHN4j6NH89VkAu7gJTQkH6A29jkpchl8zRCy8iPVvnAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon1.png
// module id = jsOG
// module chunks = 1